// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","returnFields":"_21pYXNxkjyd_5fnw9cTZmf","returnStrategyName":"_3oKKsjyFD4CcJG13tLVcJ","returnsFormValid":"_3OD3NwKtDw4HSvUEoR8izo"};